import { Box, Modal, ModalHeader, ModalSize, Text } from '@bechtel/gds';
import styled, { css } from 'styled-components';
export const ModalStyled = styled(Modal).attrs({
  size: ModalSize.DEFAULT,
})`
  width: 40%;
  max-width: 500px;
  height: 40%;
  max-height: 375px;
  transform: translateY(25%);
`;
export const ModalHeaderStyled = styled(ModalHeader)`
  display: flex;
  align-items: center;
  margin: 0;
  ${({ theme }) => css`
    padding: ${theme.spacings[200]};
    height: ${theme.spacings[800]};
  `}
`;

export const ItemStyled = styled(Box).attrs({
  flexDirection: { sm: 'row' },
  alignItems: { sm: 'center' },
})`
  ${({ theme }) => css`
    padding: ${theme.spacings[450]};
    white-space: pre-line;
  `}
`;
export const TextStyled = styled(Text)`
  line-height: 1.5;
  ${({ theme }) => css`
    padding-left: ${theme.spacings[300]};
  `}
`;
